export enum CrudType {
  Post = "create",
  Get = "read",
  Put = "update",
  Delete = "remove"
}
